import React from 'react'
import { Link } from "react-router-dom";

const Cx_extra_features_offices_region = () => {
  return (
    <section className="cx-extra-features offices-region">
    <div className="row">
        <div className="col-4 item-wrapper wow fadeInLeft duration animated" data-wow-duration="1000ms" data-wow-delay="1200ms">
            <figure>
                <img src="https://www.virtuos.com/img/north-america-bg.jpg" alt="Virtuos - North America Region"/>
            </figure>
            <div className="item">
                <span>Region</span>
                <h3 className="section-heading">North America</h3>
                <span><Link to="http://www.virtuos.com">virtuos.com</Link></span>
                <ul>
                    <li>US</li>
                    <li>Canada</li>
                    <li>Mexico</li>
                    <li>ARGENTINA</li>
                    <li>BRAZIL</li>
                </ul>
            </div>
        </div>
        <div className="col-4 item-wrapper wow fadeInUp duration animated" data-wow-duration="1000ms" data-wow-delay="900ms">
            <figure>
                <img src="https://www.virtuos.com/img/emea-bg.jpg" alt="Virtuos - EMEA Region"/>
            </figure>
            <div className="item">
                <span>Region</span>
                <h3 className="section-heading">EMEA</h3>
                <span><Link to="http://virtuos.co.uk" target="_blank">virtuos.co.uk</Link></span>
                <ul>
                    <li>EUROPE</li>
                    <li>UK</li>
                    <li>MIDDLE EAST</li>
                    <li>SOUTH AFRICA</li>
                </ul>
            </div>
        </div>
        <div className="col-4 item-wrapper wow fadeInRight duration animated" data-wow-duration="1000ms" data-wow-delay="600ms">
            <figure>
                <img src="https://www.virtuos.com/img/apac-bg.jpg" alt="Virtuos - APAC Region - India"/>
            </figure>
            <div className="item">
                <span>Region</span>
                <h3 className="section-heading">APAC</h3>
                <span><Link to="http://virtuos.com" target="_blank">virtuos.asia</Link></span>
                <ul>
                    <li>INDIA</li>
                    <li>AUSTRALIA</li>
                    <li>JAPAN</li>
                    <li>INDONESIA</li>
                    <li>REST OF APAC</li>
                </ul>
            </div>
        </div>
    </div>
</section>
  )
}

export default Cx_extra_features_offices_region
